import { $, $$ } from '@utils';
import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-tabs]')) return;

  buildSlider();
  addEventListeners();
}

// Check if slides overflow swiper-wrapper
function checkOverflow(swiper, progress) {
  const thisTabsModule = swiper.el.closest('[data-au-tabs]'),
    overflowingClass = 'au-tabs--overflowing',
    paddingRight = 16,
    sliderWidth = thisTabsModule.querySelector('[data-au-tabs-slider]').clientWidth,
    sliderWrapperWidth = thisTabsModule.querySelector('[data-au-tabs-slider-wrapper]').scrollWidth;

  if (progress >= 1) {
    thisTabsModule.classList.remove(overflowingClass);
  } else if (sliderWrapperWidth > sliderWidth - paddingRight) {
    thisTabsModule.classList.add(overflowingClass);
  } else {
    thisTabsModule.classList.remove(overflowingClass);
  }
}

function buildSlider() {
  $$('[data-au-tabs-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, A11y, FreeMode],
      navigation: {
        prevEl: slider.closest('[data-au-tabs]').querySelector('[data-au-slider-prev]'),
        nextEl: slider.closest('[data-au-tabs]').querySelector('[data-au-slider-next]'),
      },
      scrollbar: {
        el: slider.closest('[data-au-tabs]').querySelector('[data-au-slider-scrollbar]'),
      },
      slidesPerView: 'auto',
      freeMode: true,
      a11y: {
        enabled: true,
        slideRole: null,
      },
      spaceBetween: 24,
      slidesPerGroupAuto: true,
      on: {
        progress: (swiper, progress) => {
          checkOverflow(swiper, progress);
        },
      },
    });
  });
}

function addEventListeners() {
  $$('[data-au-tab]').forEach((tab) => {
    tab.addEventListener('click', toggleTab);
  });
}

function toggleTab(e) {
  const tab = e.target,
    tabContentId = tab.dataset.auTab,
    tabContent = $(`[data-au-tab-content="${tabContentId}"]`),
    tabSiblings = tab.closest('[data-au-tabs]').querySelectorAll('[data-au-tab]');

  //toggle active tab
  tabSiblings.forEach((tab) => {
    tab.classList.remove('au-active');
  });
  tab.classList.add('au-active');

  //toggle active/visible content
  tabSiblings.forEach((tab) => {
    const tabContentSiblingsId = tab.dataset.auTab,
      tabContentSiblings = $(`[data-au-tab-content="${tabContentSiblingsId}"]`);

    if (tabContentSiblings) {
      tabContentSiblings.classList.remove('au-active');
      tabContentSiblings.classList.add('au-hide');
    }
  });
  if (tabContent) {
    tabContent.classList.add('au-active');
    tabContent.classList.remove('au-hide');
  }
}

export default { init };
